import { createSelector } from '@ngrx/store';
import { selectFilterState } from '../filter.selectors';
import { FilterState } from '@immosky/types';

export const selectLivingSpaceFilterState = createSelector(
  selectFilterState,
  (state: FilterState) => state.livingSpace
);
